import React from 'react';

import { useFilingsData } from '../../../hooks/useKeywordsData';
import AddFilingDialog from './AddFilingDialog';
import { createFilingColumns } from '../../../utils/mabScrapingFilingColumns';
import ScraperTablePage from './ScraperTablePage';

export default function FilingScrapers({ projects }) {
  const {
    rows, loading, error, setError, clearError,
    addFiling, updateFiling, deleteFiling,
  } = useFilingsData();

  return (
    <ScraperTablePage
      projects={projects}
      rows={rows}
      loading={loading}
      error={error}
      setError={setError}
      clearError={clearError}
      addItem={addFiling}
      updateItem={updateFiling}
      deleteItem={deleteFiling}
      editableFields={['label', 'url']}
      createColumnsFn={createFilingColumns}
      entityName="filing"
      itemLabelField="label"
      selectLabelId="filing-project-select"
      addButtonLabel="Add Filing"
      AddDialog={AddFilingDialog}
    />
  );
}
